import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import * as JSZip from 'jszip';

export class PurchasesController {
  

    setReadyToGenerateTicketsale(id: number) {

        let address = API_ADDRESS + `/${this._controllerName }/${id}/setReadyToGenerateTicketsale`;

    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
    }
    private _controllerName: string;
  

    constructor(public _http: HttpClient) {

        this._controllerName = "purchases";
    }


    getTicketSaleErrorsCount(companyId: number) : Promise<number> {

        let address = API_ADDRESS + `/${this._controllerName }/${companyId}/ticketsales/errors/count`;

    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

               


                return result;
            });

    }  
    
    getTicketSale(purchaseId: number) : Promise<any> {

        let path = `${purchaseId}/getTicketSale`;

        let address = API_ADDRESS + `/${this._controllerName }/`+path;

    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

               


                return result;
            });

    }  
    

    downloadTicketSale(purchaseId: number, progressFunc: (progress: any) => void) {
      

        let path = `Purchases/${purchaseId}/downloadTicketSale`

            let promise = new Promise<any>(resolve => {
    
                this._http.get(API_ADDRESS + `/${path}`, {
                    responseType: "blob",
                    reportProgress: true,
                    observe: 'events'
                })
                    .subscribe((event: HttpEvent<any>) => {
    
                        switch (event.type) {
                            case HttpEventType.Sent:
                                console.log('Request has been made!');
                                break;
                            case HttpEventType.ResponseHeader:
                                console.log('Response header has been received!');
                                break;
                            case HttpEventType.DownloadProgress:
                                let progress = Math.round(event.loaded / event.total * 100);
                                console.log(`Download! ${progress}%`);
                                break;
                            case HttpEventType.Response:
                                console.log('User successfully created!', event.body);
    
                                let result = event.body;
    
                                if (result.type != 'text/plain') {
    
                                    var new_zip = new JSZip();
    
                                    // more files !
                                    new_zip.loadAsync(result)
                                        .then(function (zip) {
                                          
                                            Object.keys(zip.files).forEach(function (filename) {

                                            zip.files[filename].async("uint8array", (metadata) => {
                                                progressFunc(metadata.percent);
                                            })
                                                .then(data => {
    
                                                    var blob = new Blob([data]);
                                                    let saveAs = require('file-saver');
                                                    let file = filename;
                                                    saveAs(blob, file);
                                                    resolve(blob);
    
                                                    progressFunc(100);
    
                                                });
    
                                        });
                                    });
                                    
    
                                }
                                else {
    
                                    alert('File not found in Blob!');
                                }
    
                            //     resolve(event.body);
    
    
                        }
                    },
                        err => console.log(err)
                    );
    
    
    
                // }
                // );
            });
    
            return promise;

        }

    
}
